module.exports = __webpack_public_path__ + "img/title.c32f0709.jpg";